import { Container, Layout, Text } from 'ui/components/primitives';
import { CheckoutHeading } from 'ui/components/templates/Checkout/CheckoutView';

const GiftsContentHeader = () => (
  <>
    <Layout>
      <Container marginBottom="sp-0" marginTop="sp-6">
        <CheckoutHeading title="Você ganhou brindes! Escolha para continuar" />
      </Container>
    </Layout>
    <Layout>
      <Container marginBottom="sp-0" marginTop="sp-2">
        <Text color="medium-light-1" textAlign="left" variant="body-medium-standard">
          A escolha dos brindes é obrigatória para continuar a compra. Caso os itens fiquem
          indisponíveis, eles serão enviados em compras futuras
        </Text>
      </Container>
    </Layout>
  </>
);

export default GiftsContentHeader;
